import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "bg-gray-950/80 space-y-6 py-5",
  ref: "targetElement"
}
const _hoisted_2 = { class: "w-full px-3 md:px-3" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-12 gap-1.5 w-full mt-5 bg-[#000000d9]"
}
const _hoisted_5 = { class: "col-span-3 md:col-span-2 lg:col-span-1 flex items-center justify-center w-full pl-2 pr-1 bg-[#099500]" }
const _hoisted_6 = ["title"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-[11px] font-semibold truncate bg-black/60 px-1" }
const _hoisted_9 = { class: "col-span-9 md:col-span-10 lg:col-span-11 bg-transparent" }
const _hoisted_10 = {
  class: "flex flex-nowrap gap-1.5 w-full items-start overflow-x-scroll! py-2.5 pr-3 md:pl-0",
  style: {"scrollbar-width":"thin !important","scrollbar-color":"#0fa904 rgb(0, 0, 0) !important"}
}
const _hoisted_11 = ["title", "onClick"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "grid grid-cols-12 gap-3 md:gap-0 w-full px-0" }
const _hoisted_14 = { class: "col-span-9 md:col-span-10 xl:col-span-11 px-5" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2 xl:gap-3"
}
const _hoisted_17 = { class: "grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2 xl:gap-3" }
const _hoisted_18 = ["title", "onClick"]
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-[11px] font-semibold truncate bg-black/60 pl-3" }
const _hoisted_21 = { class: "flex items-center justify-between w-full mb-2" }
const _hoisted_22 = {
  key: 0,
  class: "grid grid-cols-3 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2"
}
const _hoisted_23 = { class: "grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-1.5 sm:gap-2" }
const _hoisted_24 = ["title"]
const _hoisted_25 = { class: "text-white text-[10px]" }
const _hoisted_26 = {
  key: 0,
  class: "absolute z-10 top-0 right-0 flex justify-center items-center w-max px-0.5"
}
const _hoisted_27 = ["onClick", "title"]
const _hoisted_28 = {
  class: "relative z-0 top-0 left-0 group w-full h-full",
  tabindex: "0"
}
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = {
  key: 0,
  class: "absolute z-10 top-0 left-0 hidden group-hover:flex group-focus:flex group-active:flex justify-center items-center w-full h-full bg-black/50"
}
const _hoisted_31 = ["onClick", "title"]
const _hoisted_32 = {
  key: 1,
  class: "absolute z-10 top-0 left-0 hidden flex justify-center items-center w-full h-full bg-black/50"
}
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "col-span-3 md:col-span-2 xl:col-span-1" }

export function render(_ctx, _cache) {
  const _component_Message = _resolveComponent("Message")
  const _component_GameNavbar = _resolveComponent("GameNavbar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Error "),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Products "),
    _createCommentVNode("\t\t<div v-else-if=\"!changeProductToGame\">"),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "default-search",
          class: "mb-2 text-sm font-medium text-gray-900 sr-only"
        }, "ค้นหา", -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none" }, [
            _createElementVNode("svg", {
              class: "w-4 h-4 text-gray-500",
              "aria-hidden": "true",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 20 20"
            }, [
              _createElementVNode("path", {
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
              })
            ])
          ], -1 /* HOISTED */)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchQuery) = $event)),
            type: "search",
            id: "default-search",
            class: "block w-full p-4 ps-10 text-sm text-white bg-[#000000d4] border border-[#ffcd18] focus:border-[#ffcd18] focus:ring-2 focus:ring-[#ffcd18] focus:outline-none rounded-lg",
            placeholder: "ค้นหา..."
          }, null, 512 /* NEED_PATCH */), [
            [_vModelText, _ctx.searchQuery]
          ])
        ])
      ]),
      (_ctx.selectedProduct?.logo.default)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "relative z-0 w-8 md:w-16 min-w-[5rem] border rounded-lg shadow-sm transition text-center overflow-hidden!",
                title: _ctx.selectedProduct?.productName.toUpperCase()
              }, [
                _createElementVNode("img", {
                  class: "static w-full h-full object-contain",
                  src: _ctx.selectedProduct?.logo.default,
                  alt: _ctx.selectedProduct?.productName.toUpperCase()
                }, null, 8 /* PROPS */, _hoisted_7),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.selectedProduct?.productName.toUpperCase()), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (product) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.productCode,
                    class: "group relative z-0 flex flex-col items-center justify-start w-8 md:w-16 min-w-[5rem] bg-black border rounded-lg shadow-sm transition cursor-pointer text-center overflow-hidden!",
                    title: product.productName?.toUpperCase(),
                    onClick: $event => (_ctx.clickProduct(product.productCode))
                  }, [
                    _createElementVNode("img", {
                      class: _normalizeClass(["static w-full h-full object-contain group-hover:grayscale-75", {
									'grayscale': product.productCode === _ctx.selectedProduct?.productCode,
									'grayscale-0': product.productCode !== _ctx.selectedProduct?.productCode
								}]),
                      src: product.logo?.default,
                      alt: product.productName?.toUpperCase()
                    }, null, 10 /* CLASS, PROPS */, _hoisted_12),
                    _createElementVNode("p", {
                      class: _normalizeClass(["absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-[11px] font-semibold truncate bg-black/60 px-1", {
									'text-gray-50': product.productCode === _ctx.selectedProduct?.productCode,
									'text-white': product.productCode !== _ctx.selectedProduct?.productCode
								}])
                    }, _toDisplayString(product?.productName.toUpperCase()), 3 /* TEXT, CLASS */)
                  ], 8 /* PROPS */, _hoisted_11))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createCommentVNode(" Product "),
        (_ctx.changeProductToGame)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-lg text-[#10ffa9] font-semibold mb-2" }, "ค่ายเกม", -1 /* HOISTED */)),
              _createCommentVNode(" Product Loading "),
              (_ctx.loadingProducts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
                      return _createElementVNode("div", {
                        key: 'game-skeleton-' + n,
                        class: "h-24 bg-[#002c18a1] animate-pulse rounded"
                      })
                    }), 64 /* STABLE_FRAGMENT */))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Product List "),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (product) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: product.productCode,
                          class: "relative z-0 w-full border rounded xl:rounded-2xl shadow-sm transition bg-black hover:bg-primary hover:text-primary cursor-pointer overflow-hidden!",
                          title: product.productName?.toLocaleUpperCase(),
                          onClick: $event => (_ctx.clickProduct(product.productCode))
                        }, [
                          _createElementVNode("img", {
                            class: "static z-0 w-full h-full top-0 left-0",
                            src: product.logo?.default,
                            alt: product.productName?.toLocaleUpperCase()
                          }, null, 8 /* PROPS */, _hoisted_19),
                          _createElementVNode("h4", _hoisted_20, _toDisplayString(product.productName?.toUpperCase()), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_18))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Games "),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-lg text-[#10ffa9] font-semibold" }, "รายการเกม", -1 /* HOISTED */)),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.clickBtnBack && _ctx.clickBtnBack(...args))),
                    type: "button",
                    class: "flex justify-center items-center w-max text-center py-1.5 px-5 bg-[url('https://168tos.sgp1.cdn.digitaloceanspaces.com/theme/btnn-2.webp')] bg-size-[100%_100%] cursor-pointer"
                  }, _cache[5] || (_cache[5] = [
                    _createElementVNode("span", { class: "text-[12px] text-white font-semibold" }, "ย้อนกลับ", -1 /* HOISTED */)
                  ]))
                ]),
                _createCommentVNode(" Games Loading "),
                (_ctx.loadingGames)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
                        return _createElementVNode("div", {
                          key: 'game-skeleton-' + n,
                          class: "h-32 md:h-32 xl:h-36 2xl:h-40 bg-[#002c18a1] animate-pulse rounded"
                        })
                      }), 64 /* STABLE_FRAGMENT */))
                    ]))
                  : (_ctx.gamesList.length === 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createCommentVNode(" Games Empty "),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-gray-400 italic" }, "ไม่พบข้อมูลเกม", -1 /* HOISTED */))
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createCommentVNode(" Games List "),
                        _createElementVNode("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gamesList, (game) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: game.loginCode,
                              class: "relative z-0 h-32 md:h-32 xl:h-36 2xl:h-40 w-full border rounded shadow-sm transition hover:bg-primary hover:text-primary overflow-hidden!"
                            }, [
                              _createElementVNode("div", {
                                class: "absolute z-10 top-0 left-0 flex justify-center items-center w-max gap-1 bg-black/60 rounded-br px-0.5 cursor-default",
                                title: 'กำลังเล่นอยู่: ' + (game?.online || 0)
                              }, [
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "relative flex size-2" }, [
                                  _createElementVNode("span", { class: "absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" }),
                                  _createElementVNode("span", { class: "relative inline-flex size-2 rounded-full bg-green-500" })
                                ], -1 /* HOISTED */)),
                                _createElementVNode("span", _hoisted_25, _toDisplayString(game?.online || 0), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_24),
                              (_ctx.auth.isLoggedIn)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("span", {
                                      onClick: $event => (_ctx.clickBtnFavorite(game?.loginCode || '', game?.isFavorite || false)),
                                      title: !game.isFavorite ? 'เพิ่มลงรายการโปรด': 'ลบออกจากรายการโปรด'
                                    }, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        class: _normalizeClass(["size-6 drop-shadow cursor-pointer hover:text-pink-600", {'text-white': game.isFavorite === false, 'text-pink-600': game.isFavorite === true}]),
                                        "aria-hidden": "true",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        fill: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("path", { d: "m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z" }, null, -1 /* HOISTED */)
                                      ]))], 2 /* CLASS */))
                                    ], 8 /* PROPS */, _hoisted_27)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("img", {
                                  class: _normalizeClass(["static z-0 w-full h-full top-0 left-0", {'group-hover:grayscale': game.active, 'grayscale': !game.active }]),
                                  src: game.logo?.vertical,
                                  alt: game.gameName?.toLocaleUpperCase()
                                }, null, 10 /* CLASS, PROPS */, _hoisted_29),
                                (game.active)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("button", {
                                        onClick: $event => (_ctx.clickGame(game?.loginCode || '')),
                                        title: 'เล่น '+game.gameName?.toLocaleUpperCase(),
                                        type: "button",
                                        class: "w-16 text-white text-xs font-semibold bg-yellow-400 rounded-lg py-1 shadow cursor-pointer"
                                      }, "เล่น", 8 /* PROPS */, _hoisted_31)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[10] || (_cache[10] = [
                                      _createElementVNode("span", { class: "text-xs font-bold" }, "ปิดปรับปรุง", -1 /* HOISTED */)
                                    ]))]))
                              ]),
                              _createElementVNode("h4", {
                                title: game.gameName?.toLocaleUpperCase(),
                                class: "absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-[11px] font-semibold truncate bg-black/60 px-1 cursor-default"
                              }, _toDisplayString(game.gameName?.toUpperCase()), 9 /* TEXT, PROPS */, _hoisted_33)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_GameNavbar)
      ])
    ])
  ], 512 /* NEED_PATCH */))
}